import { defineComponent, h } from 'vue';
import { ContainsTranslationProps } from '@/ui/components/activityLogs/types';
import { createdAt } from '@/ui/components/activityLogs/common/CreatedAt';
import { useActivityLog } from '@/ui/components/activityLogs/useActivityLog';
import { t } from '@/ui/i18n/i18n';
import { boldifyString, buildField } from '@/ui/components/activityLogs/helpers';
import { ActivityRemovedUpdated } from '@/entities/activity/model';
import { user } from '@/ui/auth/auth';

interface FieldRemovedProps extends ContainsTranslationProps {
  log: ActivityRemovedUpdated;
}

export const FieldRemoved = defineComponent<FieldRemovedProps>({
  name: 'FieldRemoved',
  props: ['log', 'valuesTranslation', 'fieldsTranslation'],
  setup(props) {
    const {
      isSettingFieldsForFirstTime,
      fieldTranslation,
      valuesToText,
    } = useActivityLog(props.log.field, props.fieldsTranslation, props.valuesTranslation);

    const hasPayload = () => props.log.payload !== null;

    return function render() {
      const username = boldifyString(props.log.user?.name ?? '');

      const message = () => {
        if (!hasPayload()) {
          return h('span', {
            domProps: {
              innerHTML: t('activity-logs.removed-field-without-value', {
                username,
                field: buildField(fieldTranslation.value, user.value.locale),
              }),
            },
          });
        }

        return isSettingFieldsForFirstTime(props.log.payload!)
          ? h('span', {
            domProps: {
              innerHTML: t('activity-logs.removed-field-without-value', {
                username,
                field: buildField(fieldTranslation.value, user.value.locale),
              }),
            },
          })
          : h('span', {
            domProps: {
              innerHTML: t('activity-logs.removed-field-with-value', {
                username,
                field: buildField(fieldTranslation.value, user.value.locale),
                value: boldifyString(valuesToText(props.log, 'old') as string),
              }),
            },
          });
      };

      return h('div', { class: 'activity-logs__log' }, [
        createdAt({ props: { log: props.log } }),
        message(),
      ]);
    };
  },
});
